import classNames from 'classnames';
import { CSSProperties, ReactNode, useMemo } from 'react';
import { IDivProps } from '../../types/props/DivProps';
import ClassName from '../../types/ClassName';

type Order = CSSProperties['order'];
type FlexGrow = CSSProperties['flexGrow'];
type FlexShrink = CSSProperties['flexShrink'];
type FlexBasis = CSSProperties['flexBasis'];
type Flex = CSSProperties['flex'];
type AlignSelf = CSSProperties['alignSelf'];
type JustifySelf = CSSProperties['justifySelf'];

export interface IFlexItemProps extends Omit<IDivProps, 'style' | 'className'> {
  order?: Order;
  flexGrow?: FlexGrow;
  flexShrink?: FlexShrink;
  flexBasis?: FlexBasis;
  flex?: Flex;
  alignSelf?: AlignSelf;
  justifySelf?: JustifySelf;
  style?: Omit<CSSProperties, 'order' | 'flexGrow' | 'flexShrink' | 'flexBasis' | 'flex' | 'alignSelf' | 'justifySelf'>;
  children: ReactNode;
  className?: ClassName;
}

function FlexItem({ children, className, style, ...flexStyles }: IFlexItemProps) {
  const styles = useMemo(
    () => ({
      ...style,
      ...flexStyles,
    }),
    [style, flexStyles]
  );

  return (
    <div className={classNames('flex-item', className)} style={styles}>
      {children}
    </div>
  );
}

export default FlexItem;
